import UnitQuiz from './component';
import _routes from './routes';

export const routes = _routes;

export default UnitQuiz;



// WEBPACK FOOTER //
// ./containers/Group/Homework/UnitQuiz/index.jsx